<template>
  <CustomTextField
    v-model="text"
    :label="label"
    @change="changeText"
  />
</template>

<script>
export default {
  props: ["value", "label"],
  data: () => ({
    text: "",
  }),
  watch: {
    value: {
      handler(val) {
        this.text = val;
      },
    },
  },
  methods: {
    changeText() {
      const urlifyText = this.urlify(this.text);
      this.$emit("input", urlifyText);
    },
    urlify(text) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, url => {
        const shortUrl = url.slice(0, 30);
        return `<a href="${url}" target="_blank">${shortUrl}...</a>`;
      });
    },
  },
};
</script>
